import fp from 'lodash/fp';

export const findPublisher = (publisherId) =>
  fp.find((publisher) => publisher.id === publisherId);



// WEBPACK FOOTER //
// ./src/services/publisher.js